import React from "react";

export default function NotificationsSection({ emailNotif, smsNotif, systemAlerts, onEmailChange, onSmsChange, onSystemAlertsChange }) {
  return (
    <div className="flex flex-col gap-3 px-5 pb-5">
      <label className="flex items-center gap-2"><input type="checkbox" checked={emailNotif} onChange={onEmailChange} className="accent-blue-500 w-4 h-4" /><span className="text-base">Email Notifications</span></label>
      <label className="flex items-center gap-2"><input type="checkbox" checked={smsNotif} onChange={onSmsChange} className="accent-blue-500 w-4 h-4" /><span className="text-base">SMS Notifications</span></label>
      <label className="flex items-center gap-2"><input type="checkbox" checked={systemAlerts} onChange={onSystemAlertsChange} className="accent-blue-500 w-4 h-4" /><span className="text-base">System Alerts</span></label>
    </div>
  );
}
